export type IssuesViewMode = "category" | "date";
export type IssuesSortDirection = "desc" | "asc";

export interface IssuesViewPreferences {
  direction: IssuesSortDirection;
  mode: IssuesViewMode;
}

export const ISSUES_VIEW_COOKIE = "issues-view";

export const ISSUES_VIEW_VARIANTS = {
  "category-asc": { direction: "asc", mode: "category" },
  "category-desc": { direction: "desc", mode: "category" },
  "date-asc": { direction: "asc", mode: "date" },
  "date-desc": { direction: "desc", mode: "date" },
} satisfies Record<string, IssuesViewPreferences>;

export type IssuesViewVariant = keyof typeof ISSUES_VIEW_VARIANTS;

export const DEFAULT_ISSUES_VIEW_VARIANT: IssuesViewVariant = "date-desc";

export function isIssuesViewVariant(value: string): value is IssuesViewVariant {
  return Object.hasOwn(ISSUES_VIEW_VARIANTS, value);
}

export function issuesViewRewriteVariant(
  cookieValue: string | undefined
): IssuesViewVariant | null {
  if (!(cookieValue && isIssuesViewVariant(cookieValue))) {
    return null;
  }
  return cookieValue === DEFAULT_ISSUES_VIEW_VARIANT ? null : cookieValue;
}
